module.exports = __webpack_public_path__ + "static/favicon-1282609b8656e31a8256ee3ae9b2277b.ico";